import { GetCategoryForLandingPageQuery } from '@productsite/src/graphql/generated/graphql-types'

export { default as Categories } from './categories'
export { default as CategoryPage } from './category-page'
export { default as CategoryPanels } from './category-panels'
export { default as CategorySEOContent } from './category-seo-content'
export { default as useCategoryPageMetadata } from './use-category-page-metadata'

export type CategoryType = NonNullable<GetCategoryForLandingPageQuery>['category']
export type CategoryNavigationType = NonNullable<CategoryType>['navigation']
export type CategoryLandingPageNavigationItemType =
  NonNullable<CategoryNavigationType>['children'][0]
export type ProductLists = NonNullable<CategoryType>['productLists']
